import script from "./SignUpPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SignUpPage.vue?vue&type=script&setup=true&lang=js"

import "./SignUpPage.vue?vue&type=style&index=0&id=42ca9114&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42ca9114"]])

export default __exports__